// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SharedData__container-a6b904 {
  flex: 1;
  box-sizing: border-box;
}

.SharedData__loader-aa7f58 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  height: 32px;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/SharedData.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  box-sizing: border-box;\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: auto;\n  margin-bottom: auto;\n  height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SharedData__container-a6b904`,
	"loader": `SharedData__loader-aa7f58`
};
module.exports = ___CSS_LOADER_EXPORT___;
